export const formatSummary = (query, loading, totalResults) => {
    const allFilters = [
        ...query.gender,
        ...query.tags,
        ...query.categories
    ].filter(x => x);

    let summary = `${loading ? '...' : totalResults} Result${totalResults === 1 ? '' : 's'}`;
    summary += query.query ? ` for <span>${query.query}</span>` : '';
    summary += allFilters.length > 0 ? ` filtered by <span>${allFilters.slice(0, 3).join(', ')}</span>` : '';
    summary += allFilters.length > 3 ? ` (+ <span>${allFilters.length-3}</span> more)` : '';
    return summary;
}


// WEBPACK FOOTER //
// ./src/utils/search.js